/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2019-09-16 11:21:02
 * @LastEditors: 李方强
 */
// 用于编写公共的代码模块

// 列表请求参数如果为空则清除函数
function operateParams(params) {
  for (const i in params) {
    if (params[i] === '' || i === 'total' || params[i] === null || params[i].length === 0 || params[i][0] === '') {
      delete params[i]
    }
  }
  return params
}

export { operateParams }
